import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LoadCSSforfirstTime from "../../../CloudStorage/LoadCSSforfirstTime";
import { payPayment } from "../../../redux/common/action";
import { useDispatch, useSelector } from "react-redux";
import { getWallet } from "../../../redux/wallet/action";
import MakePaymentButton from "./MakePaymentButton";

export default function PaymentMethodPage() {
  const path = "Assets/scss/payment.module.scss";

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const laung = localStorage.getItem("laung");
  const [lan] = useState(laung ?? "en");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { state = {} } = location;
  const { orderdetails = {} } = state;
  console.log("state", state, orderdetails);

  const isType11 = state?.type == 11 || orderdetails?.type == 11;
  const finalPrice = isType11 ? (state?.post_price || orderdetails?.post_price) : orderdetails?.post_price;

  const move = {
    type: isType11 ? 11 : orderdetails?.type,
    post_id: orderdetails?.post_id,
    type_of_post: orderdetails?.type_of_post,
    lan,
    movetolive: orderdetails?.move,
  };

  const [showMethods, setShowMethods] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState("card");
  const profile = useSelector(({ profile: { profiledata } }) => profiledata);
  const walletAmount = profile?.wallet || 0;

  useEffect(() => {
    dispatch(getWallet({ added_type: 0, searchtext: "", index: 0 }));
  }, [dispatch]);

  // ✅ SINGLE PAYMENT HANDLER
  const paypayment = (currentMethod) => {
    // Inject wallet and apple pay identifiers so your backend handles entity IDs correctly
    let data = { 
      move, 
      wallet: currentMethod === "wallet" ? 1 : 0,
      is_apple: currentMethod === "applepay" ? 1 : 0 
    };

    // packaged services
    if (orderdetails?.type_of_post == "packagedservices") {
      data = orderdetails?.bxp_request_milestone_id
        ? {
            ...data,
            type: "10",
            bxp_request_milestone_id: orderdetails.bxp_request_milestone_id,
            package_id: orderdetails.id,
          }
        : {
            ...data,
            type: "9",
            bxp_request_id: orderdetails.bxp_request_id,
            package_id: orderdetails.id,
          };

      // rental
    } else if (orderdetails?.type_of_post == "rental") {
      data = {
        ...data,
        type: "7",
        rental_request_id: orderdetails.rental_id,
        id: orderdetails.id,
      };

      // auction
    } else if (orderdetails?.type_of_post == "auction") {
      data = {
        ...data,
        type: "6",
        bid_id: orderdetails.bid_id,
        id: orderdetails.id,
      };

      // deposit
    } else if (orderdetails?.type_of_post == "deposit") {
      data = {
        ...data,
        type: "5",
        auction_id: orderdetails.auction_id,
        id: orderdetails.id,
      };

      // sale
    } else if (orderdetails?.type_of_post == "sale") {
      data = {
        ...data,
        type: "8",
        sale_request_id: orderdetails.sale_id,
      };

      // milestone or post
    } else if (orderdetails?.type == 1) {
      data = orderdetails?.milestone_id
        ? {
            ...data,
            type: "1",
            milestone_id: orderdetails.milestone_id,
            milestone_amount: orderdetails.milestone_amount,
          }
        : {
            ...data,
            type: "4",
            post_id: orderdetails.post_id,
            post_price: orderdetails.post_price,
            proposal_id: orderdetails.proposal_id,
          };

      // contest
    } else if (orderdetails?.type == 2) {
      data = {
        ...data,
        type: "2",
        post_id: orderdetails.id,
      };

      // job
    } else if (orderdetails?.type == 3) {
      data = {
        ...data,
        type: "3",
        proposal_id: orderdetails.id,
      };

      // membership
    } else if (orderdetails?.type == 14) {
      data = {
        ...data,
        type: "14",
        id: orderdetails.id,
      };
    } else if (orderdetails?.type == 17) {
      data = {
        ...data,
        type: "17",
        proposal_id: orderdetails.proposal_id,
        price: orderdetails.post_price,
      };

    } else if (isType11) {
      data = {
        ...data,
        type: "11",
        price: finalPrice,
      };
    } else {
      console.error("Unknown payment type", orderdetails);
      return Promise.reject("Invalid payment type");
    }

    return dispatch(payPayment(data, navigate));
  };

  return (
    <div className="payment container-fluid">
      <div className="row payment-row">
        <div className="col-md-4 mx-auto">
          {!showMethods ? (
            <div className="payment-sec">
              <h6>Order summary</h6>
              <div className="summary-flex">
                <p>Payable amount : </p>
                <p>$ {finalPrice}</p>
              </div>
              <button
                className="buttons background-button w-100"
                onClick={() => setShowMethods(true)}
              >
                <span>Make Payment</span>
              </button>
            </div>
          ) : (
            <div className="payment-sec" style={{ textAlign: "left" }}>
              <div className="d-flex align-items-center mb-4">
                <button
                  className="btn p-0 me-3"
                  onClick={() => setShowMethods(false)}
                  style={{ border: "none", background: "none", fontSize: "16px" }}
                >
                  <i className="fa-solid fa-chevron-left me-2"></i> Back
                </button>
              </div>

              <h6 className="mb-3">Select payment methods</h6>

              {/* CREDIT OR DEBIT CARDS */}
              <div className="method-option mb-3">
                <div
                  className="form-check d-flex align-items-center"
                  onClick={() => setSelectedMethod("card")}
                  style={{ cursor: "pointer", paddingLeft: "1.5rem" }}
                >
                  <input
                    className="form-check-input"
                    type="radio"
                    name="paymentOption"
                    id="cardOption"
                    checked={selectedMethod === "card"}
                    onChange={() => setSelectedMethod("card")}
                    style={{ marginTop: 0 }}
                  />
                  <label
                    className="form-check-label ms-2 d-flex align-items-center justify-content-between w-100"
                    htmlFor="cardOption"
                    style={{ cursor: "pointer", margin: 0 }}
                  >
                    Credit or debit cards
                  </label>
                </div>
              </div>

              {/* ✅ ADDED: APPLE PAY OPTION */}
              <div className="method-option mb-4">
                <div
                  className="form-check d-flex align-items-center"
                  onClick={() => setSelectedMethod("applepay")}
                  style={{ cursor: "pointer", paddingLeft: "1.5rem" }}
                >
                  <input
                    className="form-check-input"
                    type="radio"
                    name="paymentOption"
                    id="applePayOption"
                    checked={selectedMethod === "applepay"}
                    onChange={() => setSelectedMethod("applepay")}
                    style={{ marginTop: 0 }}
                  />
                  <label
                    className="form-check-label ms-2 d-flex align-items-center justify-content-between w-100"
                    htmlFor="applePayOption"
                    style={{ cursor: "pointer", margin: 0 }}
                  >
                    Apple Pay
                  </label>
                </div>
              </div>

              {state?.type != 11 && (
                <>
                  <h6 className="mb-3">Wallet</h6>
                  <div className="method-option mb-4">
                    <div
                      className="form-check d-flex align-items-center"
                      onClick={() => setSelectedMethod("wallet")}
                      style={{ cursor: "pointer", paddingLeft: "1.5rem" }}
                    >
                      <input
                        className="form-check-input"
                        type="radio"
                        name="paymentOption"
                        id="walletOption"
                        checked={selectedMethod === "wallet"}
                        onChange={() => setSelectedMethod("wallet")}
                        disabled={Number(walletAmount) <= 0}
                        style={{ marginTop: 0 }}
                      />
                      <label
                        className="form-check-label ms-2"
                        htmlFor="walletOption"
                        style={{ cursor: "pointer", margin: 0 }}
                      >
                        ${walletAmount}
                      </label>
                    </div>
                  </div>
                </>
              )}

              <hr />

              <h6 className="mt-4 mb-3">Order summary</h6>
              <div className="summary-flex mb-4">
                <p className="mb-0">Payable amount</p>
                <p className="mb-0">$ {finalPrice}</p>
              </div>

              <MakePaymentButton
                paypayment={paypayment}
                orderdetails={isType11 ? state : orderdetails}
                selectedMethod={selectedMethod}
                text="Save and make payment"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}